
import { destroy, get, getOne, post, put } from "../apis/httpClient"

export const detailSetting = () => getOne(`/api/v1/setting/detail`)
export const updateSetting = (params) => put(`/api/v1/setting/update`,params)